import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllHealthHistories = createAsyncThunk(
  "HealthHistory/HealthHistoryFindByLead",
  async (LeadID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HealthHistory/HealthHistoryFindByLead`,
        {
          LeadID,
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Health History:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createHealthHistory = createAsyncThunk(
  "HealthHistory/HealthHistoryInsert",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HealthHistory/HealthHistoryInsert`,
        formdata
      );
      if (response.data?.Status === 201) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
        return Promise.reject({
          message: response.data?.Details || "Something went wrong",
        });
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating health history:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateHealthHistory = createAsyncThunk(
  "HealthHistory/HealthHistoryUpdate",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HealthHistory/HealthHistoryUpdate`,
        formdata
      );
      if (response.data?.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
        return Promise.reject({
          message: response.data?.Details || "Something went wrong",
        });
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error update health history:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getHealthHistoryByID = createAsyncThunk(
  "HealthHistory/HealthHistoryFindByID",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HealthHistory/HealthHistoryFindByID`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        LeadID: result?.LeadID,
        LeadName: result?.LeadName,
        Name: result?.Name,
        MobileNo: result?.MobileNo,
        Date: result?.Date ? moment(result?.Date, "DD/MM/YYYY").toDate() : "",
        Remark: result?.Remark,
        Height: result?.Height,
        Weight: result?.Weight,
        HealthIssues: result?.HealthIssues,
        Addiction: result?.Addiction,
        HealthIssueDetails: result?.HealthIssueDetails
          ? result?.HealthIssueDetails?.map((health: any) => {
              return {
                ID: health?.ID,
                LeadID: health?.LeadID,
                HealthIssueID: health?.HealthIssueID,
                ProblemSince: health?.ProblemSince
                  ? moment(health?.ProblemSince, "DD/MM/YYYY").toDate()
                  : "",
                ProblemTo: health?.ProblemTo
                  ? moment(health?.ProblemTo, "DD/MM/YYYY").toDate()
                  : "",
                DoctorName: health?.DoctorName,
                DoctorMobileNo: health?.DoctorMobileNo,
                IsSurgery: health?.IsSurgery,
                SurgeryInfo: health?.SurgeryInfo,
                Description: health?.Description,
                MedicineDetails: health?.MedicineDetails
                  ? health?.MedicineDetails?.map((medicine: any) => {
                      return {
                        ID: medicine?.ID,
                        LeadID: medicine?.LeadID,
                        HealthIssueID: medicine?.HealthIssueID,
                        Name: medicine?.Name,
                        Dose: medicine?.Dose,
                      };
                    })
                  : [],
              };
            })
          : [],
        AddictionDetails: result?.AddictionDetails
          ? result?.AddictionDetails?.map((addiction: any) => {
              return {
                ID: addiction?.ID,
                LeadID: addiction?.LeadID,
                AddictionID: addiction?.AddictionID,
                Frequency: addiction?.Frequency,
                Value: addiction?.Value,
              };
            })
          : [],
        Reports: result?.Reports
          ? result?.Reports?.map((report: any) => {
              return {
                ID: report?.ID,
                HealthID: report?.HealthID,
                Description: report?.Description,
                HealthReport: report?.HealthReport,
              };
            })
          : [],
        IsActive: result?.IsActive,
      };
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Health History:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteHealthHistory = createAsyncThunk(
  "HealthHistory/HealthHistoryDelete",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HealthHistory/HealthHistoryDelete`,
        {
          ID: ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Health History:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const uploadHealthHistoryReports = createAsyncThunk(
  "HealthHistory/HealthHistoryReportInsert",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HealthHistory/HealthHistoryReportInsert`,
        formData
      );
      return response.data;
    } catch (error: any) {
      console.error("Error Upload Health History Reports:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteHealthHistoryReport = createAsyncThunk(
  "HealthHistory/HealthHistoryReportDelete",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/HealthHistory/HealthHistoryReportDelete`,
        {
          ID: ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Health History Reports:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
